var map = {
	"./airplane.i.svg": "bb56",
	"./china.i.svg": "d838",
	"./file-type/avi.i.svg": "969b",
	"./file-type/doc.i.svg": "3340",
	"./file-type/exe.i.svg": "56c5",
	"./file-type/file.i.svg": "fe33",
	"./file-type/jpg.i.svg": "ddd2",
	"./file-type/mp3.i.svg": "e1c9",
	"./file-type/pdf.i.svg": "252d",
	"./file-type/png.i.svg": "6eb0",
	"./file-type/ppt.i.svg": "acac",
	"./file-type/txt.i.svg": "3389",
	"./file-type/xls.i.svg": "fd3a",
	"./file-type/zip.i.svg": "0d73",
	"./turkey.i.svg": "1933",
	"./ukraine.i.svg": "eae2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a3a1";